import { Box, ButtonBase } from '@mui/material';

import { TimeRangeButton } from '@/types/markets';

const TimeRangeButtons = ({
  timeRangeButtons,
  onButtonClick,
  activeButtonIndex,
  setActiveButtonIndex
}: {
  timeRangeButtons: TimeRangeButton[];
  onButtonClick: (value: string) => void;
  activeButtonIndex: number;
  setActiveButtonIndex: (activeButtonIndex: number) => void;
}) => {
  return (
    <Box sx={{ display: 'flex', fontSize: '0.8em', ml: 2, mt: '10px', mb: 3 }}>
      {timeRangeButtons?.map((trButton, index) => {
        return (
          <ButtonBase
            key={trButton.value}
            onClick={() => {
              setActiveButtonIndex(index);
              onButtonClick(trButton.value);
            }}
          >
            <Box
              sx={{
                width: 44,
                alignItems: 'center',
                justifyContent: 'center',
                mr: 0.5,
                backgroundColor: index === activeButtonIndex ? 'primary.main' : 'gx.tileLight',
                '&:hover': {
                  color: index === activeButtonIndex ? 'text.primary' : 'rgba(255, 255, 255, 0.3)'
                }
              }}
            >
              {trButton.label}
            </Box>
          </ButtonBase>
        );
      })}
    </Box>
  );
};
export default TimeRangeButtons;
